
const initialState = {
    religions: [],
};

const religionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_RELIGIONS_NAME":
            return state = {
                ...state,
                religions: [action.payload, ...state.religions ],
            }
        case "UPDATE_RELIGIONS_NAME":
            return state = { ...state, religions: state?.religions?.map((religions) => religions._id === action.payload._id ? action?.payload : religions)}

        case "UPDATE_RELIGIONS_STATUS":
            return state = {
                ...state,
                religions: state?.religions?.map((religions) =>
                    religions._id === action.payload._id ? action?.payload : religions
                ),
            }
            case "GET_ALL_RELIGIONS":
                return {
                    ...state,
                    religions: action.payload,
                };
        default:
            return state;
    }
}

export default religionsReducer;